// extracted by mini-css-extract-plugin
module.exports = {"toggle":"ToggleButton_toggle__3VXAj","leftAlign":"ToggleButton_leftAlign__1Yb5E","rightAlign":"ToggleButton_rightAlign__mfWsQ"};